module.exports = __webpack_public_path__ + "img/icon_lab.60c60ed7.svg";